import { tokens } from '@news-mono/design-tokens'
import React from 'react'
import {
    MeterPieChart,
    MeterPieChartItem,
} from '../../../components/MeterPieChart'
import {
    RaceSwingPercentContainer,
    StyledRaceSwingContainer,
} from './TheRaceSwing.styled'

interface TheRaceSwingProps {
    swing: number | null
    colorMode?: 'light' | 'dark'
}

export const TheRaceSwing = ({ swing, colorMode }: TheRaceSwingProps) => {
    let isPlaceholder = false
    if (swing === null || swing === undefined) {
        // Swing returns null for `Others` grouping but we still want a zero display if showing other parties
        isPlaceholder = true
        swing = 0
    }

    // Don't display % if swing is returned as 0 but if rounded down or up
    // should display the label
    const swingLabel = Math.round(swing * 10) / 10
    const min = -50
    const max = 50

    let start, end
    if (swingLabel > 0) {
        start = 0
        end = swingLabel
    } else if (swingLabel < 0) {
        start = swingLabel
        end = 0
    }

    return (
        <StyledRaceSwingContainer>
            {swing !== 0 && (
                <RaceSwingPercentContainer
                    colorMode={colorMode}
                >{`${swingLabel.toFixed(1)}%`}</RaceSwingPercentContainer>
            )}
            <MeterPieChart
                min={min}
                max={max}
                innerCutoutRatio={0.6}
                items={
                    <>
                        {!isPlaceholder && (
                            <MeterPieChartItem
                                start={min}
                                end={max}
                                fill={'#E0E0E0'}
                            />
                        )}
                        {!isPlaceholder &&
                            start !== undefined &&
                            end !== undefined && (
                                <MeterPieChartItem
                                    start={start}
                                    end={end}
                                    fill={
                                        swing > 0
                                            ? tokens.thenightly.colors.palette
                                                  .neutral[100]
                                            : tokens.thenightly.colors.palette
                                                  .neutral[50]
                                    }
                                />
                            )}
                    </>
                }
            />
        </StyledRaceSwingContainer>
    )
}
